class t{constructor(t,o){this.companyName=t,this.companyCode=o}static init(){return new t("","")}static fromVo(o){return new t(o.companyName,o.companyCode)}}export{t as CompanyIdentity};
